import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import type { VkMusicBundleState } from './vkMusic.types';

export const getVkMusicBundleRoot = (state: RootState) => state.vkMusic;

const getFullName = createSelector(getVkMusicBundleRoot, (state) => state?.fullName);

const getVKID = createSelector(getVkMusicBundleRoot, (state: VkMusicBundleState): string => {
    return state.vkid;
});

const getBundleInfo = createSelector(getVkMusicBundleRoot, (state: VkMusicBundleState) => {
    return state.data;
});

export const VkMusicBundleSelectors = {
    getFullName,
    getVKID,
    getBundleInfo,
};
